import { useIntl } from 'react-intl'
import { ProductSpecsProduct, ProductSpecsLinks } from './ProductSpecs.types'

export const getTableTranslations = ({
  color,
  materials,
  height,
  width,
  depth,
  plugType,
  capsuleWarning,
  capacity,
  energySavingMode,
  voltageRating,
  tempAdjustmant,
  strengthAdjustment,
  quantityAdjustment,
  modelVersion,
  weeeNumber,
  waterTankSensor,
  waterHardness
}: ProductSpecsProduct) => {
  const { formatMessage } = useIntl()

  const translations = [
    !!color && {
      key: formatMessage({
        id: 'msp.productSpecs.color',
        defaultMessage: 'Color'
      }),
      value: color
    },
    !!materials && {
      key: formatMessage({
        id: 'msp.productSpecs.materials',
        defaultMessage: 'Materials'
      }),
      value: materials.join(', ')
    },
    !!height && {
      key: formatMessage({
        id: 'msp.productSpecs.height',
        defaultMessage: 'Height'
      }),
      value: height
    },
    !!width && {
      key: formatMessage({
        id: 'msp.productSpecs.width',
        defaultMessage: 'Width'
      }),
      value: width
    },
    !!depth && {
      key: formatMessage({
        id: 'msp.productSpecs.depth',
        defaultMessage: 'Depth'
      }),
      value: depth
    },
    !!plugType && {
      key: formatMessage({
        id: 'msp.productSpecs.plugType',
        defaultMessage: 'Device Connector'
      }),
      value: plugType
    },
    typeof capsuleWarning === 'boolean' && {
      key: formatMessage({
        id: 'msp.productSpecs.capsuleWarning',
        defaultMessage: 'Automatic diamond detection'
      }),
      value: capsuleWarning
        ? formatMessage({
            id: 'msp.product.properties.caffeineYes',
            defaultMessage: 'Yes'
          })
        : formatMessage({
            id: 'msp.product.properties.caffeineNo',
            defaultMessage: 'No'
          })
    },
    !!capacity && {
      key: formatMessage({
        id: 'msp.productSpecs.capacity',
        defaultMessage: 'Water tank capacity'
      }),
      value: capacity
    },
    typeof energySavingMode === 'boolean' && {
      key: formatMessage({
        id: 'msp.productSpecs.energySavingMode',
        defaultMessage: 'Energy saving mode'
      }),
      value: energySavingMode
        ? formatMessage({
            id: 'msp.product.properties.caffeineYes',
            defaultMessage: 'Yes'
          })
        : formatMessage({
            id: 'msp.product.properties.caffeineNo',
            defaultMessage: 'No'
          })
    },
    !!voltageRating && {
      key: formatMessage({
        id: 'msp.productSpecs.voltageRating',
        defaultMessage: 'Voltage rating'
      }),
      value: voltageRating
    },
    typeof tempAdjustmant === 'boolean' && {
      key: formatMessage({
        id: 'msp.productSpecs.tempAdjustmant',
        defaultMessage: 'Temperature adjustment'
      }),
      value: tempAdjustmant
        ? formatMessage({
            id: 'msp.product.properties.caffeineYes',
            defaultMessage: 'Yes'
          })
        : formatMessage({
            id: 'msp.product.properties.caffeineNo',
            defaultMessage: 'No'
          })
    },
    !!strengthAdjustment && {
      key: formatMessage({
        id: 'msp.productSpecs.strengthAdjustment',
        defaultMessage: 'Strength adjustment'
      }),
      value: strengthAdjustment
    },
    !!quantityAdjustment && {
      key: formatMessage({
        id: 'msp.productSpecs.quantityAdjustment',
        defaultMessage: 'Quantity adjustment'
      }),
      value: quantityAdjustment
    },
    !!modelVersion && {
      key: formatMessage({
        id: 'msp.productSpecs.modelVersion',
        defaultMessage: 'Version'
      }),
      value: modelVersion
    },
    !!weeeNumber && {
      key: formatMessage({
        id: 'msp.productSpecs.weeeNumber',
        defaultMessage: 'WEEE number'
      }),
      value: weeeNumber
    },
    typeof waterTankSensor === 'boolean' && {
      key: formatMessage({
        id: 'msp.productSpecs.waterTankSensor',
        defaultMessage: 'Water tank sensor'
      }),
      value: waterTankSensor
        ? formatMessage({
            id: 'msp.product.properties.caffeineYes',
            defaultMessage: 'Yes'
          })
        : formatMessage({
            id: 'msp.product.properties.caffeineNo',
            defaultMessage: 'No'
          })
    },
    !!waterHardness && {
      key: formatMessage({
        id: 'msp.productSpecs.waterHardness',
        defaultMessage: 'Water hardness'
      }),
      value: waterHardness
    }
  ]

  return translations
}

export const getLinksTranslations = ({
  userManual,
  quickGuide,
  firmware,
  firmware_new,
  recycling
}: ProductSpecsLinks) => {
  const { formatMessage } = useIntl()

  const translations = {
    ...(userManual && {
      userManual: formatMessage({
        id: 'msp.productSpecs.links.userManual',
        defaultMessage: 'User Manual'
      })
    }),
    ...(quickGuide && {
      quickGuide: formatMessage({
        id: 'msp.productSpecs.links.quickGuide',
        defaultMessage: 'Quick Guide'
      })
    }),
    ...(firmware && {
      firmware: formatMessage({
        id: 'msp.productSpecs.links.firmware',
        defaultMessage: 'Firmware'
      })
    }),
    ...(firmware_new && {
      firmware_new: formatMessage({
        id: 'msp.productSpecs.links.firmware_secondary',
        defaultMessage: 'Firmware (new)'
      })
    }),
    ...(recycling && {
      recycling: formatMessage({
        id: 'msp.productSpecs.links.recycling',
        defaultMessage: 'Recycling'
      })
    })
  }

  return translations
}
